<template>
  <div class="">
    <el-row :span="12">
      <el-col :span="6">
        <div>
          <el-input
            v-model="key"
            placeholder="请输入关键字或词"
            class="input-with-select"
            size="small"
            suffix-icon="el-icon-search"
          />
        </div>
      </el-col>
      <el-col :span="18" class="btn">
        <div>
          <el-button
            v-if="proStatus !== '项目已锁定'"
            v-permission="['盲底管理上传盲底']"
            type="primary"
            icon="el-icon-folder-add"
            size="small"
            @click="openUpload"
            >上传盲底
          </el-button>
          <el-button
            v-if="proStatus !== '项目已锁定'"
            v-permission="['盲底管理生成盲底']"
            type="primary"
            icon="el-icon-folder-checked"
            size="small"
            @click="handleGenerate"
            >生成盲底
          </el-button>
          <el-button
            v-if="proStatus !== '项目已锁定'"
            type="primary"
            icon="el-icon-folder-checked"
            size="small"
            @click="handleDown"
            >下载模版
          </el-button>
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        ref="filterTable"
        v-loading="loadings"
        stripe
        size="mini"
        :data="blindData"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        border
        :cell-style="cellStyle"
      >
        <el-table-column prop="code" label="文件名称">
          <template slot-scope="scope">
            <div style="font-size: 12px">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="create_user_name" label="上传者" width="160" />
        <el-table-column prop="status" label="状态" width="140" />
        <el-table-column prop="create_time" label="上传时间" width="180" />
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              class="edit"
              @click="handleView(scope.row)"
              >查看
            </el-link>
            <el-link
              :disabled="proStatus === '项目已锁定'"
              v-if="scope.row.status === '使用中'"
              type="primary"
              :underline="false"
              class="edit"
              @click="handleConfigure(scope.row)"
              >配置
            </el-link>
            <el-link
              :disabled="proStatus === '项目已锁定'"
              v-if="
                scope.row.section_type === '分配区段' &&
                scope.row.status === '未使用'
              "
              type="primary"
              :underline="false"
              class="edit"
              style="font-size: 12px"
              @click="handleEdit(scope.row)"
              >编辑
            </el-link>
            <el-link
              :disabled="proStatus === '项目已锁定'"
              v-permission="['盲底管理增加盲底']"
              type="primary"
              :underline="false"
              class="edit"
              style="font-size: 12px"
              @click="handleAdd(scope.row)"
              >增加
            </el-link>
            <el-link
              :disabled="proStatus === '项目已锁定'"
              v-if="scope.row.status === '未使用'"
              type="primary"
              :underline="false"
              class="edit"
              style="font-size: 12px"
              @click="handleApply(scope.row)"
              >使用
            </el-link>
            <el-link
              :disabled="proStatus === '项目已锁定'"
              v-if="scope.row.status === '未使用'"
              v-permission="['盲底管理测试盲底']"
              type="primary"
              :underline="false"
              class="edit"
              style="font-size: 12px"
              @click="handleTest(scope.row)"
              >测试
            </el-link>
            <el-link
              :disabled="proStatus === '项目已锁定'"
              v-if="scope.row.status === '未使用'"
              type="primary"
              :underline="false"
              class="edit"
              style="font-size: 12px"
              @click="handleDelBlind(scope.row)"
              >删除
            </el-link>
            <el-link
              type="primary"
              :underline="false"
              class="edit"
              style="font-size: 12px"
              @click="goExport(scope.row)"
              >导出
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pages">
      <el-pagination
        samll
        background
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--上传盲底-->
    <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="blindDialogVisiable"
      :show-file-list="false"
      width="40%"
      @close="cancelUpClick"
    >
      <div slot="title" class="title">上传盲底</div>
      <div class="proInfo">
        <el-row v-if="isSample" class="row" :span="12">
          <el-col :span="8" class="left">样本量：</el-col>
          <el-col :span="12">
            <div class="left">{{ sample_size }}</div>
          </el-col>
        </el-row>
        <el-row class="row" :span="12">
          <el-col :span="8" class="left">使用方法：</el-col>
          <el-col :span="12">
            <div class="left">{{ section_type }}</div>
          </el-col>
        </el-row>
        <el-row class="row" :span="12">
          <el-col :span="8" class="left">区段长度：</el-col>
          <el-col :span="12">
            <el-input
              v-model="section"
              size="mini"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              maxlength="20"
            />
          </el-col>
        </el-row>
        <el-row class="row" :span="12">
          <el-col :span="8" class="left">上传文件：</el-col>
          <el-col :span="12">
            <el-upload
              class="upload-demo"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              accept=".xls,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              :on-change="handleAvatarSuccessFile"
            >
              <el-button size="mini" type="primary">点击上传</el-button>
            </el-upload>
          </el-col>
        </el-row>
        <div class="fileName">{{ fileName }}</div>
      </div>
      <div class="desc">
        区段长度与上传文件不一致，盲底会无法使用，请慎重填写！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          :loading="uploadloading"
          size="mini"
          @click="uploadClick"
          >确 定</el-button
        >
        <el-button size="mini" @click="cancelUpClick">取 消</el-button>
      </span>
    </el-dialog>
    <!--生成盲底-->
    <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="generateDialogVisible"
      width="45%"
      @close="cancelDenerate"
    >
      <div slot="title" class="title">{{ text }}</div>
      <div v-loading="loading2" class="proInfo">
        <el-row class="row" :span="12">
          <el-col :span="8" class="left" style="text-align: right"
            >盲底名称：</el-col
          >
          <el-col :span="12">
            <el-input
              v-model="name"
              size="mini"
              :disabled="disableLength || readyOnly"
            />
          </el-col>
        </el-row>
        <el-row v-if="isSample" class="row" :span="12">
          <el-col :span="8" class="left" style="text-align: right"
            >样本量：</el-col
          >
          <el-col :span="12">
            <div class="left">{{ sample_size }}</div>
          </el-col>
        </el-row>
        <el-row class="row" :span="12">
          <el-col :span="8" class="left" style="text-align: right"
            >区段使用方法：</el-col
          >
          <el-col :span="12">
            <div class="left">{{ section_type }}</div>
          </el-col>
        </el-row>
        <el-row class="row" :span="12">
          <el-col :span="8" class="left" style="text-align: right"
            >区段长度：</el-col
          >
          <el-col :span="12">
            <el-input
              v-model="section_length"
              type="number"
              @input="countNum_"
              onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
              size="mini"
              :disabled="disableLength || readyOnly"
              @mousewheel.native.prevent
            />
          </el-col>
        </el-row>
        <el-row v-if="isCompete" class="row" :span="12" style="margin: 0">
          <el-col
            :span="8"
            class="left"
            style="text-align: right; font-weight: 600"
            >各中心增加区段数：</el-col
          >
          <el-row class="row" :span="12"> </el-row>
        </el-row>

        <el-row
          v-if="isCompete"
          class="row"
          :span="12"
          v-for="(item, index) in centerData"
          :key="index + 'top'"
        >
          <el-col :span="8" class="left" style="text-align: right"
            >{{ item.name }}：</el-col
          >
          <el-col :span="12">
            <el-input
              v-model="item.num"
              size="mini"
              type="number"
              onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
              :disabled="readyOnly"
              @input="countNum"
              @mousewheel.native.prevent
            />
          </el-col>
        </el-row>

        <el-row v-if="isCompete" class="row" :span="12" style="margin: 0">
          <el-col
            :span="8"
            class="left"
            style="text-align: right; font-weight: 600"
            >各分层创建比例：</el-col
          >
          <el-row class="row" :span="12"> </el-row>
        </el-row>
        <el-row
          v-if="isCompete"
          class="row"
          :span="12"
          v-for="(item, index) in layeredData"
          :key="index"
        >
          <el-col :span="8" class="left" style="text-align: right"
            >{{ item.desc }}：
          </el-col>
          <el-col :span="12">
            <el-input
              v-model="count[item.id]"
              type="number"
              onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
              size="mini"
              style="width: 100px"
              :disabled="readyOnly"
              @mousewheel.native.prevent
            />
          </el-col>
        </el-row>

        <el-row class="row" :span="12">
          <el-col :span="8" class="left" style="text-align: right"
            >{{ sectionText }}：</el-col
          >
          <el-col :span="12">
            <el-input
              v-model="section_count"
              type="number"
              onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
              min="1"
              size="mini"
              :disabled="readyOnly || only"
            />
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="!readyOnly"
          v-preventReClick
          size="mini"
          type="primary"
          :loading="createLoading"
          @click="generate"
          >确 定</el-button
        >
        <el-button v-if="!readyOnly" size="mini" @click="cancelDenerate"
          >取 消</el-button
        >
        <!--配置-->
        <el-button
          v-if="readyOnly"
          size="mini"
          type="primary"
          @click="cancelDenerate"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!--查看-->
    <el-dialog
      :visible.sync="dialogTableVisible"
      :close-on-click-modal="false"
      width="60%"
      center
    >
      <div slot="title" class="title">查看盲底</div>
      <div style="width: 100%; height: 400px; overflow: auto">
        <el-table
          v-loading="loading"
          size="mini"
          border
          :data="gridData"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            align="center"
            property="number"
            label="序号"
            width="80"
          />
          <el-table-column
            align="center"
            property="section_number"
            label="区段号"
            width="150"
          />
          <el-table-column
            v-if="different === '分配区段'"
            align="center"
            property="unit_name"
            label="中心"
            width="150"
          />
          <el-table-column
            v-if="different === '分配区段' && projectDetail.is_need_layer"
            align="center"
            property="layer_dict"
            label="分层"
            width="150"
          >
            <template slot-scope="scope">
              <div>{{ layeredClick(scope.row.layer_dict) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="group_name"
            label="试验组名"
          />
        </el-table>
      </div>
    </el-dialog>
    <!--编辑-->
    <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="blindEditDialogVisiable"
      width="50%"
      @close="handleCancel"
    >
      <div slot="title" class="title">编辑盲底</div>
      <div class="proInfo" style="height: 300px">
        <el-table
          v-loading="loadingEdit"
          :data="editTableData"
          max-height="250"
          border
          size="mini"
          style="width: 100%"
        >
          <el-table-column prop="section_number" label="区段号" width="80" />
          <el-table-column prop="blind_unit_id" label="中心编号" width="180">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.blind_unit_id"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="(item, a) in listData"
                  :key="a"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="" label="分层代码">
            <template slot-scope="scope" style="display: flex">
              <div style="display: flex; padding-left: 5px">
                <div
                  v-for="(item, index) in factorData"
                  :key="index"
                  style="display: flex; padding-right: 5px"
                >
                  <span>{{ item.name }}：</span>
                  <el-select
                    v-model="scope.row.layer_dict[item.id]"
                    placeholder="请选择"
                    size="mini"
                  >
                    <el-option
                      v-for="(i, a) in item.item_list"
                      :key="a"
                      :label="i.name"
                      :value="i.id"
                    />
                  </el-select>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          size="mini"
          @click="handleEditClick"
          >确 定</el-button
        >
        <el-button size="mini" @click="handleCancel">取 消</el-button>
      </span>
    </el-dialog>
    <!--配置-->
    <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="disposeDialogVisible"
      width="45%"
      @close="cancelDenerate"
    >
      <div slot="title" class="title">盲底配置</div>
      <div v-loading="loading2" class="proInfo">
        <el-row class="row" :span="12">
          <el-col :span="8" class="left">盲底名称：</el-col>
          <el-col :span="12">
            <el-input v-model="name" size="mini" :disabled="true" />
          </el-col>
        </el-row>
        <el-row v-if="isSample" class="row" :span="12">
          <el-col :span="8" class="left">样本量：</el-col>
          <el-col :span="12">
            <div class="left">{{ sample_size }}</div>
          </el-col>
        </el-row>
        <el-row class="row" :span="12">
          <el-col :span="8" class="left">区段使用方法：</el-col>
          <el-col :span="12">
            <div class="left">{{ section_type }}</div>
          </el-col>
        </el-row>
        <el-row class="row" :span="12">
          <el-col :span="8" class="left">区段长度：</el-col>
          <el-col :span="12">
            <el-input
              v-model="section_length"
              type="number"
              onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
              size="mini"
              :disabled="true"
            />
          </el-col>
        </el-row>
        <el-row v-if="isCompete" class="row">
          <div style="">各中心增加区段数：</div>
          <div
            v-for="(item, index) in arr"
            :key="index"
            style="
              display: flex;
              text-align: left;
              background-color: #f5f7fa;
              padding: 10px 0;
            "
          >
            <div style="width: 50%">{{ item.key }}</div>
            <div>{{ item.value }}</div>
          </div>
        </el-row>
        <el-row v-if="isCompete" class="row">
          <div>各分层创建比例：</div>
          <el-row>
            <el-col v-for="(item, index) in arr1" :key="index" :span="2">{{
              countClick(item.key, index)
            }}</el-col>
            <el-col :span="2">=</el-col>
            <el-col :span="10">
              <span v-for="(item, index) in arr1" :key="index">
                <span
                  type="number"
                  onKeypress="return(/[\d\.]/.test(String.fromCharCode(event.keyCode)))"
                  size="mini"
                  style="width: 50px; padding: 0 10px"
                />{{ item.value
                }}<span>{{ countRight(item.value, index) }}</span>
              </span>
            </el-col>
          </el-row>
        </el-row>
        <el-row class="row" :span="12">
          <el-col :span="8" class="left">{{ sectionText }}：</el-col>
          <el-col :span="12">
            <el-input
              v-model="section_count"
              size="mini"
              :disabled="readyOnly || only"
            />
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--配置-->
        <el-button
          v-if="readyOnly"
          size="mini"
          type="primary"
          @click="handleCancelPeizhi"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  blindList,
  uploadBlind,
  generate,
  apply,
  detail,
  append,
  deleteBlind,
  updateBlind,
  get_section_list,
} from "@/api/blindFundus";
import { detailPro } from "@/api/platform";
import { getProjectId, getProStatus, getSection } from "@/utils/auth";
import { addGenerate } from "@/views/blindFundus/addGenerate";
import { cancelGenerate } from "@/views/blindFundus/cancelGenerate";

export default {
  name: "BlindFundus",
  data() {
    return {
      userDetail: JSON.parse(sessionStorage.getItem("iwrs_user")),
      proStatus: "", // 项目状态
      cellStyle: {
        textAlign: "center",
      },
      blindData: [],
      currentPage: 1,
      pageSize: 10,
      total: null,
      proId: "",
      key: "",
      blindDialogVisiable: false,
      section: null,
      sample_size: null, // 样本量
      section_type: "", // 区段使用方法(竞争，分配)
      ratio: null, // 分组比例
      isSample: true,
      generateDialogVisible: false, // 生成盲底
      centerData: [],
      section_length: null,
      name: "",
      section_count: "",
      isCompete: true,
      disableLength: false,
      blindId: "", // 盲低id
      readyOnly: false,
      dialogTableVisible: false,
      gridData: [],
      loading: false,
      loadings: false,
      text: "生成盲底",
      num: [],
      layeredData: [],
      count: {},
      sectionText: "创建区段数",
      only: true, // 生成盲底的时候，创建区段数禁止填写
      newObj: {},
      loading2: false,
      different: "", // 分配、 竞争
      blindEditDialogVisiable: false,
      editTableData: [],
      listData: [], // 所有中心数组
      centerValue: {}, // 中心value
      factorData: [], // 分层因子
      loadingEdit: false,
      fileName: "",
      a: {},
      disposeDialogVisible: false,
      peizhiCenterData: [],
      arr: [],
      arr1: [],
      createLoading: false,
      uploadloading: false,
      projectDetail: {},
    };
  },
  computed: {
    countClick() {
      return function (item, index) {
        if (this.layeredData.length - 1 !== index) {
          return item + ":";
        } else {
          return item;
        }
      };
    },
    countRight() {
      return function (item, index) {
        if (this.layeredData.length - 1 !== index) {
          return ":";
        } else {
          return "";
        }
      };
    },
    // 分配区段 分层处理
    layeredClick() {
      return function (items) {
        const keys = Object.keys(items);
        console.log(999);
        console.log(keys);
        let str = "";
        keys.map((item, index) => {
          console.log("展示");
          console.log(item);
          if (keys.length - 1 === index) {
            str += item + ":" + items[item].value;
          } else {
            str += item + ":" + items[item].value + ",";
            console.log(str);
          }
        });
        return str;
      };
    },
  },
  watch: {
    key(value) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.getList, 500);
    },
  },
  created() {
    this.proStatus = getProStatus();
    this.different = getSection();
    if (this.different === "分配区段") {
      this.only = true;
    } else {
      this.only = false;
    }
    this.proId = getProjectId();
    console.log(this.different);
    this.getList();
    this.getInfo();
  },
  methods: {
    handleCancelPeizhi() {
      this.disposeDialogVisible = false;
    },
    unique(arr) {
      const res = new Map();
      return arr.filter(
        (arr) => !res.has(arr.section_number) && res.set(arr.section_number, 1)
      );
    },
    goExport(row) {
      let urltest =
        sessionStorage.getItem("iwrs_environment") === "PROD"
          ? "2/v1.0/iwrs/blind/export"
          : "/v1.0/iwrs/blind/export";
      const a = document.createElement("a");
      a.href =
        process.env.VUE_APP_BASE_API +
        urltest +
        "?project_id=" +
        this.proId +
        "&id=" +
        row.id +
        "&user_id=" +
        this.userDetail.id +
        "&random=" +
        Math.random();
      // console.log(baseUrl);
      a.target = "_blank";
      a.click();
    },
    handleEdit(row) {
      this.blindId = row.id;
      this.loadingEdit = true;
      this.blindEditDialogVisiable = true;
      const param = {
        project_id: this.proId,
        id: row.id,
      };
      get_section_list(param)
        .then((res) => {
          if (res && res.code === 0) {
            this.loadingEdit = false;
            // this.editTableData = this.unique(res.data.item_list)
            this.editTableData = res.data;
            console.log(this.editTableData);
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleCancel() {
      this.blindEditDialogVisiable = false;
    },
    handleEditClick() {
      console.log(111);
      console.log(this.editTableData);
      // const editTableData = this.editTableData.map(item => {
      //   const obj = {}
      //   obj.id = item.id
      //   obj.blind_unit_id = item.blind_unit_id
      //   const layer_dict = {}
      //   for (const items in item.layer_dict) {
      //     console.log('census')
      //     console.log(items)
      //     console.log(item.layer_dict[items].layer_item_id)
      //     // items = item.layer_dict[items].layer_item_id
      //     console.log(item)
      //     // const a = {}
      //     this.a[items] = item.layer_dict[items].layer_item_id
      //     console.log(12112312)
      //     console.log(this.a)
      //     // layer_dict.push(a)
      //   }
      //   obj.layer_dict = this.a
      //   console.log(layer_dict)
      //   return obj
      // })
      // console.log(editTableData)
      const params = {
        project_id: this.proId,
        id: this.blindId,
        section_list: this.editTableData,
      };
      // console.log('入参数')
      // console.log(params)
      updateBlind(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.blindEditDialogVisiable = false;
            this.$message({
              message: res.msg,
              tyep: "success",
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    countNum() {
      let num = 0;
      this.centerData.map((item) => {
        console.log(item);
        if (item.num) {
          num += Number.parseInt(item.num);
        }
      });
      console.log(num);
      this.section_count = num;
    },
    countNum_() {
      console.log(this.sample_size);
      console.log(this.section_length);

      !this.centerData.length
        ? (this.section_count = this.sample_size / this.section_length)
        : null;
    },
    // 获取信息
    getInfo() {
      this.loading2 = true;
      detailPro({ id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            // console.log(res)
            this.projectDetail = res.data;
            this.loading2 = false;
            this.sample_size = Number.parseInt(res.data.sample_size);
            if (this.sample_size === 0) {
              this.isSample = false;
            }
            this.section_type = res.data.section_type;
            if (this.section_type === "竞争区段") {
              this.isCompete = false;
            }
            // 编辑盲底中中心选项
            this.listData = res.data.blind_unit_list.map((item) => {
              const obj = {};
              obj.name = item.name;
              obj.id = item.id;
              obj.blind_unit_id = item.unit_id;
              return obj;
            });
            // 分层
            this.factorData = res.data.layer_list;
            console.log(99);
            console.log(this.listData);
            this.centerData = res.data.blind_unit_list.map((item) => {
              item.num = "";
              return item;
            });

            this.layeredData = res.data.combination_layer_list;

            const ratio = res.data.group_list.map((item) => {
              return item.ratio;
            });
            this.ratio = ratio.reduce((pre, cur) => {
              console.log(pre);
              console.log(cur);
              return pre + cur;
            });
            console.log(this.ratio);
          } else {
            this.$message(res.msg);
          }
          console.log(res);
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    openUpload() {
      this.blindDialogVisiable = true;
    },
    handleGenerate() {
      this.text = "生成盲底";
      this.sectionText = "创建区段数";
      this.generateDialogVisible = true;
      this.disableLength = false;
      this.readyOnly = false;
    },
    cancelDenerate() {
      cancelGenerate(this);
    },
    generate() {
      this.createLoading = true;
      this.centerData.map((item, index) => {
        this.newObj[item.key] = item.num;
      });
      const params = {
        project_id: this.proId,
        name: this.name,
        section_length: this.section_length,
        section_count: this.section_count,
        unit_count_dict: this.newObj,
        layer_scale: this.count,
      };
      if (!this.blindId) {
        addGenerate(params, this);
      } else {
        params.id = this.blindId;
        this.editGenerate(params);
      }
    },
    editGenerate(params) {
      append(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.blindId = "";
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.cancelDenerate();
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally((res) => {
          this.createLoading = false;
        });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getList() {
      this.loadings = true;
      const params = {
        project_id: this.proId,
        key: this.key,
        page: this.currentPage - 1,
        page_size: this.pageSize,
      };
      blindList(params)
        .then((res) => {
          console.log("res----->", res);
          if (res && res.code === 0) {
            this.loadings = false;
            if (res.data && res.data.length > 0) {
              this.blindData = res.data;
              this.total = res.total;
            } else {
              this.blindData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleAvatarSuccessFile(file) {
      this.fileName = file.name;
      console.log(file);
      this.file = file;
    },
    // 上传盲底
    uploadClick() {
      const formData = new FormData();
      formData.append("project_id", this.proId);
      formData.append("section_length", this.section);
      formData.append("file", this.file.raw);
      this.uploadloading = true;
      uploadBlind(formData)
        .then((res) => {
          this.uploadloading = false;
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.cancelUpClick();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          this.uploadloading = false;
          console.log(res.msg);
        });
    },
    // 下载模版
    handleDown() {
      const baseUrl =
        process.env.VUE_APP_BASE_API +
        "/v1.0/iwrs/blind/down/template?project_id=" +
        this.proId +
        "&user_id=" +
        this.userDetail.id;
      window.open(baseUrl, "_self");
    },
    // 取消上传盲底
    cancelUpClick() {
      this.fileName = "";
      this.section = null;
      this.blindDialogVisiable = false;
      this.uploadloading = false;
      this.getList();
    },
    handleApply(row) {
      console.log(row);
      this.$confirm(
        `是否确认使用该 <span style="color: #698CFC;font-size: 14px;font-weight: bold;">${row.name} </span>作为正式盲底?` +
          '<div style="color: #8C8C8C;font-size: 12px;">注意：如该盲底未经系统测试，建议先进行盲底测试。确定盲底后不能修改或删除盲底，只能增加盲底。</div>',
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "btn-custom-cancel",
        }
      )
        .then(() => {
          const params = {
            id: row.id,
            project_id: this.proId,
          };
          apply(params)
            .then((res) => {
              if (res && res.code === 0) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.getList();
              } else {
                this.$message(res.msg);
              }
            })
            .catch((res) => {
              console.log(res.msg);
            });
        })
        .catch(() => {});
    },
    // 查看盲底配置
    handleConfigure(row) {
      this.text = "配置盲底";
      this.sectionText = "区段数";
      this.peizhiCenterData = [];
      this.blindId = row.id;
      // this.generateDialogVisible = true
      this.disposeDialogVisible = true;
      this.readyOnly = true;
      const params = {
        project_id: this.proId,
        id: row.id,
      };
      detail(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.name = res.data.name;
            this.section_length = res.data.section_length;
            this.section_count = res.data.section_count;
            for (const i in res.data.unit_dict) {
              console.log(i);
              const obj = {};
              obj[i] = res.data.unit_dict[i];
              this.peizhiCenterData.push(obj);
            }
            this.arr = this.peizhiCenterData.map((item) => {
              const keys = Object.keys(item);
              const obj = {};
              obj.key = keys[0];
              obj.value = item[keys[0]];
              return obj;
            });
            const array = [];
            for (const d in res.data.layer_dict) {
              const obj = {};
              obj[d] = res.data.layer_dict[d];
              array.push(obj);
            }
            this.arr1 = array.map((item) => {
              const keys = Object.keys(item);
              const obj = {};
              obj.key = keys[0];
              obj.value = item[keys[0]];
              return obj;
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleAdd(row) {
      this.text = "增加盲底";
      this.sectionText = "增加区段数";
      this.blindId = row.id;
      this.generateDialogVisible = true;
      const params = {
        project_id: this.proId,
        id: row.id,
      };
      detail(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.disableLength = true;
            this.name = res.data.name;
            this.section_length = res.data.section_length;
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleDelBlind(row) {
      this.$confirm(
        `是否确认删除 <span style="color: #698CFC;font-size: 14px;font-weight: bold;">${row.name} </span>盲底?` +
          '<div style="color: #8C8C8C;font-size: 12px;"></div>',
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "btn-custom-cancel",
          type: "warning",
        }
      )
        .then(() => {
          const params = {
            id: row.id,
            project_id: this.proId,
          };
          deleteBlind(params)
            .then((res) => {
              if (res && res.code === 0) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.getList();
              } else {
                this.$message(res.msg);
              }
            })
            .catch((res) => {
              console.log(res.msg);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleView(row) {
      this.gridData = [];
      this.loading = true;
      this.dialogTableVisible = true;
      const params = {
        project_id: this.proId,
        id: row.id,
      };
      detail(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.loading = false;
            this.gridData = res.data.item_list;
            console.log(this.gridData);
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleTest(row) {
      console.log(row);
      this.$router.push({
        path: "/blindFundus/blindTest",
        query: {
          id: row.id,
          name: row.name,
        },
      });
    },
  },
};
</script>

<style scoped>
.btn {
  text-align: right;
}

.container-table {
  margin-top: 20px;
}

.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}

.proInfo {
  background-color: #f0f5ff;
  padding: 15px;
  padding-bottom: 10px;
}

.proInfo .el-col-6 {
  text-align: right;
}

.row {
  margin: 0px 0 20px;
  font-size: 14px;
  color: #595959;
}

.left {
  line-height: 26px;
}

.pages {
  margin-top: 30px;
  text-align: right;
}

.edit {
  font-size: 12px;
  margin-right: 10px;
}

.desc {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 5px;
  text-align: center;
}

.el-dialog__header {
  padding: 0px;
}

.container-table {
  border: 1px solid #e5eeff;
}

.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}

.fileName {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
}

table {
  border-collapse: collapse;
}

.templateColumn {
  border-right: 1px solid #aaa;
}

table.templateContainer > table:nth-child(3n) {
  border: none;
}

.columnsContainer:last-of-type .templateColumn {
  border-right: 0px;
}

input[type="number"] {
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>

